"use strict";

import angular from "angular";

import template from "./coins-indicator.component.html";
import "./coins-indicator.component.scss";

import _ from "lodash";

class CoinsIndicator {
    constructor() {
        this.liquidity = 0;
        this.obligations = {};
        this.available = {};
        this.coinsLength = 0;
        this.pointsHistoric = [];
    }

    $onInit() {
        this._setData();
    }

    $onChanges(changes) {
        if (!_.isEmpty(_.get(changes, "currentPeriod.previousValue"))) {
            this._setData();
        }
    }

    _setData() {
        if (!_.get(this.series, "length")) return;
        this.liquidity = this._getLast(_.get(this.configs, "coins._id"));
        this.obligations = {
            v: this._getLast(_.get(this.configs, "fixedCoins._id")),
            name: this.series.find(
                (s) => s._id === _.get(this.configs, "fixedCoins._id")
            ).name
        };
        this.available = {
            v: this._getLast(_.get(this.configs, "label._id")),
            name: this.series.find(
                (s) => s._id === _.get(this.configs, "label._id")
            ).name
        };

        //this.coinsLength = new Array(Math.ceil(this.liquidity || 0));
        this.coinsLength = new Array(Math.ceil(6 || 0));

        const points = this.points.filter(
            (p) => p.s === _.get(this.historicSeries, "[0]._id")
        );

        if (this.goals) {
            const DISPONIVEL = "n8w6onwcqt1xiacwoyxoe";
            const seriesGoals = this.series.find(
                (s) => s.referenceId == DISPONIVEL
            );
            this.historicSeries.push(seriesGoals);
            const goalsPoints = this.points.filter(
                (p) => p.s === seriesGoals._id
            );
            points.push(...goalsPoints);
        }

        this.pointsData = points;
        this.seriesData = this.historicSeries;
    }

    /**
     * @private
     * Identify the last point of the serie
     * @param {String} _id Id
     * @returns {Object}
     */
    _getLast = (_id) => {
        const point = _.findLast(this.points, { s: _id });

        return _.get(point, "m.v");
    };
}

CoinsIndicator.$inject = [];

const name = "coinsIndicator";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        historicSeries: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<"
    },
    controller: CoinsIndicator,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
